import { useNavigate } from "react-router-dom";
import { transitionTo } from "./Transition";
import { BUSINESSES } from "../data/businesses";

export default function GlobalFooter() {
  const navigate = useNavigate();
  const go = (e, href) => {
    e.preventDefault();
    transitionTo(navigate, href);
  };

  return (
    <footer className="relative border-t border-white/10" data-testid="global-footer">
      <div className="px-[6vw] pb-10 pt-20">
        <a
          href="/"
          onClick={(e) => go(e, "/")}
          className="block font-display text-[11vw] font-black uppercase leading-[0.85] tracking-tighter transition-colors duration-300 hover:text-amber md:text-[7vw]"
          data-testid="footer-brand"
        >
          OA Holding
        </a>

        <div className="mt-16 grid gap-12 md:grid-cols-4 md:gap-8">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">Businesses</p>
            <ul className="mt-4 space-y-2">
              {BUSINESSES.map((b) => (
                <li key={b.slug}>
                  <a
                    href={`/businesses/${b.slug}`}
                    onClick={(e) => go(e, `/businesses/${b.slug}`)}
                    className="text-sm text-bone/70 transition-colors duration-300 hover:text-amber"
                    data-testid={`footer-business-${b.slug}`}
                  >
                    {b.shortName}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">Company</p>
            <ul className="mt-4 space-y-2">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Businesses", "/businesses"],
                ["Capabilities", "/capabilities"],
                ["Contact", "/contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    onClick={(e) => go(e, href)}
                    className="text-sm text-bone/70 transition-colors duration-300 hover:text-amber"
                    data-testid={`footer-link-${label.toLowerCase()}`}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">Head Office</p>
            <address className="mt-4 text-sm not-italic leading-relaxed text-bone/70" data-testid="footer-address">
              OA Holding CO LTD.
              <br />
              Trust Company Complex
              <br />
              Ajeltake Road, Ajeltake Island
              <br />
              Majuro, Marshall Islands MH 96960
              <br />
              P.O. Box 1405
            </address>
            <a
              href="mailto:info@oaholding.co"
              className="mt-4 inline-block text-sm text-bone transition-colors duration-300 hover:text-amber"
              data-testid="footer-email"
            >
              info@oaholding.co
            </a>
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-3 border-t border-white/10 pt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-smoke md:flex-row md:items-center md:justify-between">
          <span data-testid="footer-copyright">© 2026 OA Holding CO LTD.</span>
          <span>Majuro — Worldwide</span>
        </div>
      </div>
    </footer>
  );
}
